import clsx from 'clsx'
import NextLink from 'next/link'
import { useTranslation } from 'react-i18next'

import type { SubCategoryListProps } from './type'

import { ChevronRightOutlinedIcon } from '@/components/icons/ChevronRightOutlined'
import { Icon } from '@/components/ui'
import { ROUTE } from '@/const/route'
import { getMargedCategoryItems } from '@/utils/features/category'

const href = (categoryId: SubCategoryListProps['category']['categoryId']) => {
  return `${ROUTE.items}?categoryIds.0=${categoryId}`
}

export const SubCategoryList = ({ category }: SubCategoryListProps) => {
  const { t } = useTranslation()
  // NOTE: サブカテゴリーだけでなく、大分類の「すべて」も表示する
  const subCategories = getMargedCategoryItems(category)

  return (
    <div className={clsx('tw-border-t tw-border-gray-300')}>
      <div
        className={clsx(
          'tw-h-11',
          'tw-flex tw-items-center',
          'tw-px-4',
          'tw-border-b tw-border-gray-300',
          'tw-text-sm tw-font-bold',
          'tw-bg-primary-50'
        )}
      >
        {category.categoryName}
      </div>
      <ul>
        {subCategories.map((subCategory) => (
          <li key={`${category.categoryId}-${subCategory.categoryId}`}>
            <NextLink href={href(subCategory.categoryId)}>
              <span
                className={clsx(
                  'tw-h-11',
                  'tw-flex tw-items-center tw-justify-between',
                  'tw-px-4',
                  'tw-border-b tw-border-gray-300',
                  'tw-text-sm',
                  'tw-cursor-pointer hover:tw-opacity-75',
                  'tw-transition tw-duration-stateChange'
                )}
              >
                <span className={clsx('tw-inline-flex', 'tw-truncate')}>
                  <span className={clsx('tw-truncate')}>
                    {subCategory.categoryName === 'すべて'
                      ? t('category.all')
                      : subCategory.categoryName}
                  </span>
                  <span className={clsx('tw-ml-1', 'tw-flex-none')}>{`(${
                    subCategory.numberOfProducts
                  } ${t('category.count')})`}</span>
                </span>
                <span className={clsx('tw-ml-1', 'tw-flex-none')}>
                  <Icon
                    icon={ChevronRightOutlinedIcon}
                    size={'2xl'}
                    color={'description'}
                  />
                </span>
              </span>
            </NextLink>
          </li>
        ))}
      </ul>
    </div>
  )
}
